export default __webpack_public_path__ + "static/media/phone.ae93bc95.svg";